import * as Yup from "yup";

export const departmentSchema = Yup.object({
    department: Yup.string().required(" Enter Department"),
    status: Yup.string().required("Select Status"),
    // password: Yup.string().required(" Enter Password"),
});
